import { api } from "./api";

/**
 * Sesión lista para guardar, a partir de la respuesta del backend.
 *
 * Los permisos llegan como nombres; se acepta también la forma antigua (un
 * objeto por permiso) para que una pestaña abierta contra un backend recién
 * desplegado no se quede sin acceso a nada.
 */
export const toSession = (result) => ({
    ...result.user,
    token: result.token,
    roles: result.roles ?? [],
    permissions: (result.permissions ?? []).map((permission) =>
        typeof permission === 'string' ? permission : permission?.name
    ).filter(Boolean),
});

export const loginService = (credentials) =>
    api.post('/auth/login', credentials, { auth: false });

export const registerService = (body) => api.post('/auth/register', body, { auth: false });

/**
 * Sesión vigente según el servidor.
 *
 * Los permisos se guardan en localStorage al iniciar sesión y allí se quedan:
 * si un administrador cambia el rol de alguien, o si cambia el catálogo de
 * permisos, esa copia queda obsoleta y la interfaz sigue ofreciendo pantallas
 * que la API ya rechaza. Se vuelven a pedir al arrancar la aplicación.
 */
export const fetchSessionService = (token) =>
    api.get('/auth/user', { headers: { Authorization: `Bearer ${token}` } });
